import { useEffect } from "react";

const PLAY_STORE_URL =
  "http://play.google.com/store/apps/details?id=com.zoopers.app&hl=en_IN";

const APP_STORE_URL = "https://apps.apple.com/us/app/zoopers-now/id6762121370";

const WEBSITE_URL = "https://zoopersnow.com";

function AppRedirect() {
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(ua)) {
      window.location.replace(PLAY_STORE_URL);
    } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      window.location.replace(APP_STORE_URL);
    } else {
      window.location.replace(WEBSITE_URL);
    }
  }, []);

  return <p>Redirecting...</p>;
}

export default AppRedirect;
